import { render } from "./UserMetadataComponent.vue?vue&type=template&id=6589497a"
import script from "./UserMetadataComponent.vue?vue&type=script&lang=js"
export * from "./UserMetadataComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__